import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-editable-textarea-content .tb-editable-textarea-textarea-wrapper', {
    margin: '-7px -7px auto -7px',
});

cssRule('.tb-editable-textarea-bottom', {
    position: 'relative',
    paddingTop: '6px',
});

cssRule('.tb-character-counter', {
    float: 'right',
});

cssRule('.tb-character-counter.tb-exceeded-length', {
    color: applyColor(DesignTokens.color.font.default.error, '#c41723'),
});

